import { render, staticRenderFns } from "./SplitsDelivered.vue?vue&type=template&id=63f1a327&scoped=true"
import script from "./SplitsDelivered.vue?vue&type=script&lang=js"
export * from "./SplitsDelivered.vue?vue&type=script&lang=js"
import style0 from "./SplitsDelivered.vue?vue&type=style&index=0&id=63f1a327&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1a327",
  null
  
)

export default component.exports